import { createApp } from 'vue'
import { createPinia } from 'pinia'
import * as Sentry from '@sentry/vue'

import App from './App.vue'
import router from './router'

import './assets/main.css'

// Capture impersonation token from URL hash before createApp() and Sentry.init().
// Hash fragments are not sent to the server — the token never appears in nginx
// access logs. Sentry is initialized below, so the token won't appear in
// Sentry breadcrumbs either.
const _hash = window.location.hash
if (_hash.startsWith('#impersonation_token=')) {
  sessionStorage.setItem(
    'impersonation_token',
    decodeURIComponent(_hash.slice('#impersonation_token='.length)),
  )
  history.replaceState(null, '', window.location.pathname + window.location.search)
}

const app = createApp(App)

if (import.meta.env.VITE_SENTRY_DSN) {
  Sentry.init({
    app,
    dsn: import.meta.env.VITE_SENTRY_DSN,
    environment: import.meta.env.MODE,
    tracesSampleRate: 0.1,
  })
}

app.use(createPinia())
app.use(router)

app.mount('#app')
